
// export const RadioGroup = ({ label, name, value, options, onChange, disabled, required, isReport }) => {

//     if (isReport) {
//       return (
//           <p>{label}{required && "*"}: {value}</p>
//       );
//     }

//     return (
//       <div className="checkbox-group">
//         <div className="form-group">
//         <label>{label}{required && "*"}</label>
//         <div className="client-type">
//           {options.map((option, index) => (
//             <label key={index} className="custom-checkbox">
//               <input
//                 type="radio"
//                 name={name}
//                 key={`input-${index}`}
//                 value={option.value}
//                 checked={value === option.value}
//                 onChange={onChange}
//                 disabled={disabled}
//                 required={required}
//               />
//               <span className="checkmark"></span> {option.display_value}
//             </label>
//           ))}
//         </div>
//         </div>
//       </div>
//     );
//   };
  


import React from "react";
import { useTooltips } from "../../hooks/toolTips"; // adjust the path as needed
import { Tooltip } from "react-tooltip";
import { FaInfoCircle } from "react-icons/fa";
import "react-tooltip/dist/react-tooltip.css";


const getTooltip = (tooltips, label, name) => {
  if (!Array.isArray(tooltips)) {
    console.warn("❌ Tooltips is not an array:", tooltips);
    return "";
  }

  const match = tooltips.find(
    (t) =>
      (label && t.Label?.toLowerCase().trim() === label.toLowerCase().trim()) ||
      (name && t.Name?.toLowerCase().trim() === name.toLowerCase().trim())
  );

  if (!match) {
    console.log(`🔍 No tooltip match found for label="${label}" name="${name}"`);
    return "";
  }

  const tooltipText = match.Tooltip?.trim();
  console.log(`🧩 Found tooltip for "${label || name}": "${tooltipText}"`);

  if (!tooltipText || tooltipText.toLowerCase() === "123" || tooltipText.length < 7) {
    console.log("⚠️ Tooltip skipped (too short or invalid):", tooltipText);
    return "";
  }

  return tooltipText;
};
export const RadioGroup = ({
  label,
  name,
  value,
  options,
  onChange,
  disabled,
  required,
  isReport,
  tooltip // optional manual override
}) => {
  const tooltips = useTooltips();
  const resolvedTooltip = (tooltip || getTooltip(tooltips, label?.replace(/:$/, ""), name))?.replace(/\n/g, "<br/>");

  if (isReport) {
    return (
      <p>
        {label}
        {required && "*"}: {value}
      </p>
    );
  }

  return (
    <div className="checkbox-group">
      <div className="form-group">
        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {label}
          {required && "*"}
          {resolvedTooltip && (
            <>
              <span
                data-tooltip-id={`tooltip-${name}`}
                style={{ cursor: "pointer" }}
              >
                <FaInfoCircle size={14} color="#07b1b0" />
              </span>
              <Tooltip
                id={`tooltip-${name}`}
                place="right"
                className="custom-tooltip clickable-tooltip"
                openOnClick={true}
                clickable={true}
                globalCloseEvents={{ clickOutsideAnchor: true }}
              >
                <div className="tooltip-text" dangerouslySetInnerHTML={{ __html: resolvedTooltip }} />
              </Tooltip>
            </>
          )}
        </label>
        <div className="client-type">
          {options.map((option, index) => (
            <label key={index} className="custom-checkbox">
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={onChange}
                disabled={disabled}
                required={required}
              />
              <span className="checkmark"></span> {option.display_value}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};
